import { AnotherToken, LendContract, Lending, PriceList, Token } from '@jdiyield/interfaces'
import BigNumber from 'bignumber.js'
import Web3 from 'web3'

import { findToken, makeBatchRequest } from '../utils'

export const getIronLending = async (
  web3: Web3,
  walletAddress: string,
  lendContract: LendContract,
  tokens: Token[],
  priceList: PriceList
): Promise<Lending> => {
  try {
    const lendTokens = lendContract?.lendTokens || []
    const { rToken } = await import('@jdiyield/abi')
    const tokenData = await makeBatchRequest(
      web3,
      lendTokens.flatMap((tokenAddress) => {
        const contract = new web3.eth.Contract(rToken as any, tokenAddress)
        const underlying =
          tokenAddress === '0xCa0F37f73174a28a64552D426590d3eD601ecCa1'
            ? '0x0000000000000000000000000000000000001010'
            : contract.methods.underlying().call
        return [
          contract.methods.balanceOf(walletAddress).call,
          contract.methods.borrowBalanceStored(walletAddress).call,
          contract.methods.exchangeRateStored().call,
          underlying,
          contract.methods.borrowIndex().call
        ]
      })
    )

    const chunkTokenData = [...new Array(tokenData.length / 5)].map((_, i) => {
      const index = i * 5
      return {
        rToken: lendTokens[i],
        balanceOf: tokenData[index],
        borrowBalanceStored: tokenData[index + 1],
        exchangeRateStored: tokenData[index + 2],
        underlying: tokenData[index + 3],
        borrowIndex: tokenData[index + 4]
      }
    })

    const resultData = chunkTokenData.map(
      ({ balanceOf, borrowBalanceStored, exchangeRateStored, underlying, borrowIndex }) => {
        const tokenInfo = findToken(tokens, underlying)
        const decimals = tokenInfo?.decimals || 18
        const collateralRatio = new BigNumber(exchangeRateStored).div(`1e18`)
        const borrowRatio = new BigNumber(borrowIndex).div(`1e18`)
        const collateralBalance = new BigNumber(balanceOf).div(`1e${decimals}`).multipliedBy(collateralRatio)
        const borrowBalance = new BigNumber(borrowBalanceStored).div(`1e${decimals}`).multipliedBy(borrowRatio)
        const usdPerCoin = priceList[tokenInfo?.address]?.usd || 0

        return {
          collateralToken: {
            usdPerCoin,
            logo: tokenInfo?.logo || '',
            symbol: tokenInfo?.symbol || '???',
            name: tokenInfo?.name || '???',
            amount: collateralBalance,
            value: collateralBalance.toNumber(),
            decimals,
            address: tokenInfo?.address,
            valueUSD: collateralBalance.multipliedBy(usdPerCoin).toNumber()
          } as AnotherToken,
          borrowToken: {
            usdPerCoin,
            logo: tokenInfo?.logo || '',
            symbol: tokenInfo?.symbol || '???',
            name: tokenInfo?.name || '???',
            amount: borrowBalance,
            value: borrowBalance.toNumber(),
            decimals,
            address: tokenInfo?.address,
            valueUSD: borrowBalance.multipliedBy(usdPerCoin).toNumber()
          } as AnotherToken
        }
      }
    )

    return {
      collateralTokens: resultData.map(({ collateralToken }) => collateralToken).filter(({ value }) => value !== 0),
      borrowTokens: resultData.map(({ borrowToken }) => borrowToken).filter(({ value }) => value !== 0),
      supplyBalance: resultData.reduce((sum, { collateralToken }) => sum + collateralToken.valueUSD, 0),
      borrowBalance: resultData.reduce((sum, { borrowToken }) => sum + borrowToken.valueUSD, 0)
    }
  } catch (error) {
    console.log(lendContract, error)
    return {
      collateralTokens: [],
      borrowBalance: 0,
      borrowTokens: [],
      supplyBalance: 0
    }
  }
}
